import InputItemList from '@shared/components/core/field/list/TextInputList';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IClientTokenRedirectEditorProps {
    tokenAdditionalRedirectUris: string[];
    tokenRedirectUrlHost: string | undefined;
    onUpdate: (
        additionalField: 'tokenAdditionalRedirectUris',
        additionalValue: string[],
        hostField: 'tokenRedirectUrlHost',
        hostValue: string | undefined
    ) => void;
}

export default function ClientTokenRedirectEditor({
    tokenAdditionalRedirectUris,
    tokenRedirectUrlHost,
    onUpdate,
}: IClientTokenRedirectEditorProps) {
    const { t } = useTranslation();

    // Compute combined values directly - no state needed
    const displayValues = useMemo(() => {
        return tokenRedirectUrlHost
            ? [tokenRedirectUrlHost, ...tokenAdditionalRedirectUris]
            : [...tokenAdditionalRedirectUris];
    }, [tokenRedirectUrlHost, tokenAdditionalRedirectUris]);

    const handleChange = (updatedUris: string[]) => {
        // Split back into host (first item) and additional (rest)
        const newHost = updatedUris.length > 0 ? updatedUris[0] : undefined;
        const newAdditional = updatedUris.slice(1);

        onUpdate('tokenAdditionalRedirectUris', newAdditional, 'tokenRedirectUrlHost', newHost);
    };

    return (
        <InputItemList
            initialValues={displayValues}
            legend={t('common:organization.projects.tokenRedirect.title')}
            description={t('common:organization.projects.tokenRedirect.description')}
            onChange={handleChange}
        />
    );
}
